module.exports = __webpack_public_path__ + "static/img/101025.c8b15711.png";